import { LanguageType } from '@app/interfaces/interfaces';
import { setLocale } from '@app/store/slices/locale';
import { useCallback, useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from './reduxHooks';

export const useLanguage = (): { language: LanguageType; setLanguage: (locale: LanguageType) => void } => {
  const dispatch = useAppDispatch();

  const { locale } = useAppSelector((state) => state.locale);

  const handleChangeLanguage = useCallback(
    (locale: LanguageType) => {
      dispatch(setLocale(locale));
    },
    [dispatch],
  );

  /**
   * That dispatch used the setLocale action, which always sets langIsSetByUser: true. That ran on startup with the current locale (often de), 
   * so the app thought the user had chosen German. Then the locale slice ignored the canton API’s languageDefault (e.g. Italian), while AppRouter 
   * still synced i18n to Redux’s locale — so you kept seeing German on login.
   */
  // useEffect(() => {
  //   handleChangeLanguage(locale);
  // }, [locale, handleChangeLanguage]);

  return useMemo(
    () => ({ language: locale as LanguageType, setLanguage: handleChangeLanguage }),
    [handleChangeLanguage, locale],
  );
};
